import React, { useState } from "react";

import { importMenuItems } from "services/menu/rest";

import { Banner, Button, Modal, Spinner, Stack, UploadDropzone } from "shared/ui";

import { useMenuEditorContext } from "features/MenuEditor/context";

import { Errors } from "./styles";

const ACCEPT = ".xlsx,.xls,.csv";
const UNSUPPORTED_FILE_ERROR = "Поддерживаются только xlsx, xls и csv";

export const UploadItemsDialog = () => {
    const state = useMenuEditorContext();

    const [uploading, setUploading] = useState<boolean>(false);
    const [errors, setErrors] = useState<string[]>([]);

    const upload = async (files: File[]) => {
        // Пустой список — дропзона отсеяла файл по accept, и без своего сообщения это выглядит
        // так, будто кабинет молча ничего не сделал.
        if (files.length === 0) {
            state.notify.showError(UNSUPPORTED_FILE_ERROR);
            return;
        }

        setUploading(true);
        setErrors([]);

        try {
            const res = await importMenuItems(state.menuId, files[0]);

            // Часть строк могла завестись и при ошибках, поэтому список обновляем всегда,
            // а диалог оставляем открытым, пока человек не увидит проблемные строки.
            state.refreshAll();

            if (res.errors.length > 0) {
                setErrors(res.errors);
                return;
            }

            state.notify.showSuccess("Позиции загружены");
            state.closeDialog();
        } catch (error) {
            state.notify.showError("Не удалось загрузить файл", error);
        } finally {
            setUploading(false);
        }
    };

    return (
        <Modal
            open
            onClose={state.closeDialog}
            title="Загрузить позиции из файла"
            actions={
                <Button variant="outlined" color="neutral" onClick={state.closeDialog}>
                    Закрыть
                </Button>
            }
        >
            <Stack $gap={16}>
                <Banner tone="info" title="Excel или CSV">
                    Файл создаёт новые позиции: существующие не обновляются, повторная загрузка
                    того же файла добавит их ещё раз. Категория с таким же названием
                    переиспользуется. Если нужного шаблона нет под рукой — скачайте его в панели
                    «Управление меню».
                </Banner>

                {uploading ? (
                    <Spinner />
                ) : (
                    <UploadDropzone
                        onDrop={upload}
                        accept={ACCEPT}
                        hint="xlsx, xls, csv"
                    />
                )}

                {errors.length > 0 && (
                    <Errors>
                        {errors.map((message, index) => (
                            <li key={index}>{message}</li>
                        ))}
                    </Errors>
                )}
            </Stack>
        </Modal>
    );
};
